module.exports = __webpack_public_path__ + "media/src/public/img/heart-124b828822afcf6875d09bc14468b4fc.png";